import React from "react";
import { Tag, ProjectPageCard } from "Pieces";
import "./ProjectPage.css";
import { useParams } from "react-router-dom";
import { projectData } from "data";
import { Fade } from "motion";
import { Text } from "foundation";
import { Flex } from "@chakra-ui/react";

const ProjectPage: React.FC = () => {
  const { projectId } = useParams<{ projectId?: string }>();
  if (projectId) {
    const project = projectData[projectId];
    return (
      <Fade className="content">
        <div className="project__header">
          <Text textStyle="h4">{project.client}</Text>
          <Text textStyle="h2">{project.headline}</Text>
          <div className="project__tags">
            {project.tags.map((tag, index) => (
              <Tag name={tag} key={index} />
            ))}
          </div>
          {project.intro && (
            <div className="project__intro">
              <Text textStyle="p">{project.intro}</Text>
            </div>
          )}
          {project.link && (
            <div className="project__links">
              {project.link.map((link, index) => (
                <a
                  className="project__link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={link.link}
                  key={index}
                >
                  <Text textStyle="h4">{link.label}</Text>
                </a>
              ))}
            </div>
          )}
        </div>
        <div className="content-offset project__content">
          {project.content.map((content, index) => (
            <ProjectPageCard
              content={content}
              type={project.type[0]}
              index={index}
              key={index}
            />
          ))}
        </div>
        {project.credits && (
          <div className="project__credits">
            <Text textStyle="h4">Credits</Text>
            {project.credits.map((content, index) =>
              content.link ? (
                <Flex gap="0.25rem" direction="column">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={content.link}
                    key={index}
                  >
                    <Text textStyle="h3">{content.name}</Text>
                    <Text textStyle="h4">{content.role}</Text>
                  </a>
                </Flex>
              ) : (
                <Flex key={index} gap="0.25rem" direction="column">
                  <Text textStyle="h3">{content.name}</Text>
                  <Text textStyle="h4">{content.role}</Text>
                </Flex>
              )
            )}
          </div>
        )}
      </Fade>
    );
  } else {
    return <h1>Loading</h1>;
  }
};

export default ProjectPage;
